<template>
  <div v-if="hasStandard" class="OrderManageCreate-root">
    <span v-if="odrNo && !oneMoreOrder" class="odr-txt">订单号 {{  odrNo  }}</span>
    <a-form-model ref="orderForm" class="order-manage-create-page" :model="form" layout="horizontal" :rules="rules"
      :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
      <a-spin :spinning="loading.onSubmit">
        <a-space direction="vertical">
          <div v-if="isEnterprise" class="contrat-container">
            <div class="projectTitle">
              <img src="@/assets/img/icon_fuwushang.png" alt="">
              <cutCarrier></cutCarrier>
            </div>
          </div>
          <div class="block-container">
            <div>
              <block-title class="basic" title="基本信息" icon-title="仓">
                <div class="content">
                  <a-row>
                    <a-col v-if="tab!==tabListType.DELIVER_TRANSPORT" :span="8">
                      <a-form-model-item label="订单类型" :colon="false" :label-col="{ span: 6 }"
                        :wrapper-col="{ span: 18 }">
                        <div>
                          <div v-if="isEditPage">
                          <span v-if="form.scene === warehouseType.in">仓配入库</span>
                          <span v-else-if="form.scene === warehouseType.out">仓配出库</span>
                        </div>
                        <a-radio-group v-else v-model="form.scene" class="radio-global"
                          @change="orderWarehouseChange($event.target.value, true)">
                          <a-radio :value="warehouseType.in">入库</a-radio>
                          <a-radio :value="warehouseType.out">出库</a-radio>
                          <a-radio :value="warehouseType.inventory">盘点</a-radio>
                        </a-radio-group>
                        </div>
                      </a-form-model-item>
                    </a-col>
                    <a-col v-if="fetchOrganization&&!isInventory"  :span="8">
                      <a-form-model-item label="运营项目" :colon="false" prop="projectId" :label-col="{ span: 6}"
                        :wrapper-col="{ span: 18 }">
                        <project-select v-model="form.projectId" :list="projectList" :edit="isEditPage"
                          @checkedList="checkProject" @onSearch="onSearchProjectList" />
                        <div v-if="!projectALLData.length">
                          暂无运营项目，请联系管理员创建
<!--                          <a-button style="padding: 0" type="link" @click="toProject">创建运营项目</a-button>-->
                        </div>
                      </a-form-model-item>
                    </a-col>
                    <!-- 仓库盘点 -->
                    <inventoryBaseForm 
                      v-if="isInventory"
                      :form="form" 
                      :is-edit-page="isEditPage" 
                      :one-more-order="oneMoreOrder" 
                      :warehouse-list="warehouseList"
                      :list-flag="listFlag"
                      :disabled-date="disabledDate" 
                    >
                      <template>
                         <select-dom v-if="listFlag" v-model="form.deliverWarehouseCode" :text="form.defultName"
                          :edit="isEditPage" :one-more-order="oneMoreOrder" :list="warehouseList" placeholder="请选择仓库"
                          @onSearch="onSearchProject" @checkedList="checkedWarehouse" @remove="removeData" />
                      </template>
                    </inventoryBaseForm>
                  </a-row>
                  <a-row v-if="!isInventory">
                    <a-col :span="6">
                      <a-form-model-item :colon="false" :label="form.scene === warehouseType.in ? '入库仓库' : '出库仓库'"
                        :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }" prop="deliverWarehouseCode">
                        <select-dom v-if="listFlag" v-model="form.deliverWarehouseCode" :text="form.defultName"
                          :edit="isEditPage" :one-more-order="oneMoreOrder" :list="warehouseList" placeholder="请选择仓库"
                          @onSearch="onSearchProject" @checkedList="checkedWarehouse" @remove="removeData" />
                      </a-form-model-item>
                      <div v-if="isEditPage" class="maks"></div>
                    </a-col>
                    <a-col :span="6">
                      <a-form-model-item :colon="false" :label="form.scene === warehouseType.in ? '计划到仓时间' : '交货时间'"
                        :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }" prop="planTime">
                        <a-date-picker 
                        v-model="form.planTime"  
                        show-time
                        format="YYYY-MM-DD HH:mm:ss" :disabled-date="disabledDate"
                        :placeholder="form.scene === warehouseType.in ? '请选择计划到仓时间' : '请选择交货时间'" />
                      </a-form-model-item>
                    </a-col>
                    <a-col v-if="form.scene === warehouseType.in && !oneMoreOrder" :span="6">
                      <a-form-model-item :colon="false" label="要求存储温区" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }">
                        <a-select v-model="temperatureLayer" placeholder="请选择要求存储温区">
                          <a-select-option  v-for="item in temperatureLayerOptions"
                                           :key="item.value" :value="item.value">
                            {{  item.label  }}
                          </a-select-option>
                        </a-select>
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="6">
                      <a-form-model-item :colon="false" :label="form.scene === warehouseType.in ? '入库类型' : '出库类型'"
                        :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }" prop="type">
                        <a-select v-model="form.type" placeholder="请选择" @change="changeType">
                          <a-select-option v-for="item in form.scene === warehouseType.in ? filterList() : OUTTYPE"
                            :key="item.value" :value="item.value" :disabled="item.disabled">
                            {{  item.lable  }}
                          </a-select-option>
                        </a-select>
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                  <!-- <a-row>
                    <a-col :span="24">
                      <a-form-model-item label="仓操作项" :colon="false" :label-col="{ span: 2 }"
                        :wrapper-col="{ span: 21 }" prop="operateOptions">
                        <a-checkbox-group v-model="form.operateOptions"
                          :options="WAREHOUSEACTIONS[form.scene] && WAREHOUSEACTIONS[form.scene].list || []" />
                      </a-form-model-item>
                    </a-col>
                  </a-row> -->
                </div>
              </block-title>
            </div>
            <div v-if="!isDischarge || form.scene === warehouseType.in || !form.needTransport|| isInventory">
              <block-title title="货品信息">
                <GoodsInfo ref="GoodsInfoRef" v-model="form.stationGoodsList" :need-transport="form.needTransport"
                  :prop-prefix="`stationGoodsList`" :scene="form.scene"
                  :deliver-warehouse-code.sync="form.deliverWarehouseCode" :shipper-code="form.customerCode"
                  :is-edit-page="isEditPage" :one-more-order="oneMoreOrder" :select-warehouseid="form.selectWarehouseid"
                  :temperature-layer="temperatureLayer" :form.sync="form"
                  @afreshVali="handleAfreshVali" @refreshAll="handleRefreshAll" @changeGoods="handleGoods"/>
              </block-title>
            </div>
          </div>
          <a-card>
          </a-card>
<!--          <div class="added-services">-->
<!--            <h2>增值服务</h2>-->
<!--            <p>-->
<!--              <a-icon type="exclamation-circle" />-->
<!--              选择增值服务可能会产生额外费用-->
<!--            </p>-->
<!--          </div>-->
          <div v-if="!isInventory" class="block-container">
            <div v-if="form.scene === warehouseType.in">
              <block-title title="送货方式">
                <el-row>
                  <el-col :md="8" :sm="24">
                    <a-form-model-item class="ml32" label="" :colon="false" :label-col="{ span: 0 }" :wrapper-col="{ span: 16 }">
                      <a-radio-group v-model="form.needTransport" class="radio-global" :disabled="isEditPage"
                        @change="orderWarehouseChange($event.target.value)">
                        <a-radio :value="0">送达</a-radio>
                        <a-radio
                          :disabled="!warehouseContract && (warehouseContract && warehouseContract.TRANSPORT.length) <= 0"
                          :value="1">提货</a-radio>
                      </a-radio-group>
                    </a-form-model-item>
                  </el-col>
                  <el-col v-if="form.needTransport && !isBind && productList.length" :md="16" :sm="24">
                    <a-form-model-item label="运输类型" :colon="false" :label-col="{ span: 3 }" :wrapper-col="{ span: 19 }">
                      <a-radio-group :value="form.productType" class="radio-global">
                        <a-radio v-for="item in productList" :key="item.productCode" :value="item.productCode"
                          @click="changeProductType">
                          {{  item.productName  }}
                        </a-radio>
                      </a-radio-group>
                    </a-form-model-item>
                  </el-col>
<!--                  <el-col v-if="form.needTransport && showCarType" :md="8" :sm="24">-->
<!--                    <a-form-model-item label="车型" :colon="false" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">-->
<!--                      <select-dom v-if="carTypeflag" v-model="form.carTypeId" :text="form.carTypeName"-->
<!--                        :list="carTypeList" :edit="true" placeholder="请选择车型" @checkedList="changeCarType"-->
<!--                        @onSearch="onSearchCarType" @remove="removeCarType" />-->
<!--                    </a-form-model-item>-->
<!--                  </el-col>-->
                </el-row>
                <carrier-info v-if="form.scene === warehouseType.in && !form.needTransport" v-model="form.carrierInfoReq" :all-car-type-list="allCarTypeList" />
              </block-title>
            </div>
            <div
              v-if="form.needTransport === 1 || (form.scene === warehouseType.in && form.type === INTYPECODE.return)">
              <block-title class="origin-station" :title="tab === tabListType.DELIVER_TRANSPORT?'起始地信息':'提货地信息'" :icon-title="tab === tabListType.DELIVER_TRANSPORT?'发':'提'">
                <StartStation v-model="form.startStation" :type="form.type" :scene="form.scene" subtitle="提货地信息"
                  :deliver-warehouse-code="form.deliverWarehouseCode" :customer-code="form.customerCode"
                  @change="changeStation" />
              </block-title>
            </div>
            <div
              v-if="form.needTransport === 1 || (form.needTransport !== 1 && form.scene === warehouseType.out && form.type !== OUTTYPECODE.transfer && form.type !== OUTTYPECODE.transferBetween)">
              <block-title v-for="(station, index) in endStationData" :key="index" class="destination"
                :title="endStationData.length > 1 ? `目的地信息${index + 1}` : '目的地信息'" icon-title="收">
                <span v-if="endStationData.length !== 1" slot="icon-right" class="deleteStyle"
                  @click="onDeleteEndStation(index, station)">
                  <a-icon type="delete" />删除
                </span>
                <EndStation v-if="form.needTransport === 1 || form.scene === warehouseType.out"
                  v-model="form.endStation[index]" :show-add-button="!isEditPage && form.endStation.length < 10"
                  :tab="tab"
                  :show-delete-button="!isEditPage && form.endStation.length !== 1" :prop-prefix="`endStation.${index}`"
                  :scene="form.scene" :deliver-warehouse-code="form.deliverWarehouseCode" :shipper-code="shipperCode"
                  @add="onAddEndStation" @change="changeStation" @delete="onDeleteEndStation(index)">
                  <template v-if="isDischarge && form.scene === warehouseType.out && form.needTransport">
                    <GoodsInfo v-model="form.endStation[index].stationGoodsList" :need-transport="form.needTransport"
                      :prop-prefix="`endStation.${index}.stationGoodsList`" :scene="form.scene"
                      :deliver-warehouse-code="form.deliverWarehouseCode" :shipper-code="form.customerCode"
                      :is-edit-page="isEditPage" :one-more-order="oneMoreOrder"
                      :temperature-layer="temperatureLayer"
                      :select-warehouseid="form.selectWarehouseid" @afreshVali="handleAfreshVali"
                      @refreshAll="handleRefreshAll" />
                  </template>
                </EndStation>
                <EndStationNoVerification v-else v-model="form.endStation[index]"
                  :show-add-button="!isEditPage && form.endStation.length < 10"
                  :show-delete-button="!isEditPage && form.endStation.length !== 1" :scene="form.scene"
                  :deliver-warehouse-code="form.deliverWarehouseCode" :shipper-code="shipperCode" @add="onAddEndStation"
                  @change="changeStation" @delete="onDeleteEndStation(index)" />
                <el-row v-if="form.scene === warehouseType.out && form.needTransport === 0">
                  <el-col :md="24" :sm="24" class="with-card-box">
                    <a-form-model-item label="提货凭证" :colon="false" :label-col="{ span: 2 }" :wrapper-col="{ span: 16 }">
                      <File v-model="form.credentials" :file-number="1" :max-size="20" />
                    </a-form-model-item>
                  </el-col>
                </el-row>
                <el-row v-if="form.scene === warehouseType.in">
                  <el-col :md="24" :sm="24" class="with-card-box">
                    <a-form-model-item label="随车附件" :colon="false" :label-col="{ span: 2 }" :wrapper-col="{ span: 16 }">
                      <File v-model="form.accessoryFiles" :file-number="1" :max-size="20" />
                    </a-form-model-item>
                  </el-col>
                </el-row>
              </block-title>
            </div>
          </div>
          <div
            v-if="form.needTransport === 1 && isDischarge && form.scene === warehouseType.out && (form.endStation.length < 30 || form.endStation.length !== 1)"
            class="station-add">
            <a-button v-if="form.endStation.length < 30 && !form.isLine" block type="link" @click="onAddEndStation">
              <a-icon type="plus" />
              添加收货地
            </a-button>
          </div>
          <div class="block-container margin-top">
            <div>
              <block-title title="其他信息">
                <a-row>
                  <a-col :md="12" :sm="24">
                    <a-form-model-item label="外部单号" :colon="false" :label-col="{ span: 4 }" :wrapper-col="{ span: 19 }">
                      <a-input v-model="form.crmNumber" :disabled="orderStatus === PREDRAFT" :max-length="30"
                               placeholder="请输入外部单号" />
                    </a-form-model-item>
                  </a-col>
                  <a-col :md="12" :sm="24">
                    <a-form-model-item label="备注" :colon="false" :label-col="{ span: 4 }" :wrapper-col="{ span: 19 }">
                      <a-input v-model="form.remark" :max-length="100" :auto-size="{ minRows: 3, maxRows: 3 }"
                        class="remark-input" placeholder="请输入，最多不超100字" type="textarea" />
                    </a-form-model-item>
                  </a-col>
                  <a-col :md="12" :sm="24">
                    <a-form-model-item label="上传附件" :colon="false" :label-col="{ span: 4 }" :wrapper-col="{ span: 19 }">
                      <File ref="fileRef"  v-model="form.fileList"/>
                    </a-form-model-item>
                  </a-col>
                </a-row>
              </block-title>
            </div>
          </div>
        </a-space>
      </a-spin>
    </a-form-model>
    <fix-bottom class="create-btns">
      <template slot="button">
        <a-button v-track-click="{ trackName: '在线下单-仓-取消订单' }" @click="closeOrder">
          取消
        </a-button>
        <a-button v-track-click="{ trackName: isEditPage ? '在线下单-仓-编辑订单' : '在线下单-仓-提交订单' }"
          v-auth="$_ButtonPermission.ORDER_PLACEORDER" class="margin-left" type="primary" :loading="upLoading"
          @click="onSubmit">
          {{  isEditPage ? '保存' : '提交订单'  }}
        </a-button>
      </template>
    </fix-bottom>
    <div v-if="noAuthentication" class="authMaks" @click="authFlag = true">
      <auth v-if="authFlag" @success="authSuccess" @cancel="authFlag = false"></auth>
    </div>
    <err-batch ref="errBatch" :is-discharge.sync="isDischarge" @changeGoods="changeGoods"
      @changeDischargeGoods="changeDischargeGoods" />
    <settlementModes ref="settlementModes" />
  </div>
</template>

<script>
import moment from 'moment';
import loadingMixin from '@thales/loading'
import FixBottom from '@/components/fix-bottom/index.vue';

import FormValidator from '@/constants/formValidator'

// import BlockPanel from '@/components/panel/BlockPanel.vue'
import BlockTitle from '@/components/panel/BlockTitle.vue'
import Auth from '@/components/authentication/Auth.vue'
import sortNumber from '@/utils/sortNumber'
import ProjectSelect from '@/components/select/OrderSelect'
import cutCarrier from '@/pages/orderManage/components/cutCarrier.vue'
import { tabListType } from "@/pages/orderManage/constant";
import {getStationByWarehouse} from "@/api/orderRules";
import {scrollToTargetWareHourse} from "@/utils/util";
import { mapGetters } from 'vuex'
import settlementModes from '@/components/settlementModes/index.vue'
import {batchSaveCountPlanFormOms,externalInitiationOrderDetail} from '@/api/inventory'
import SelectDom from './components/SelectDom.vue'
import ErrBatch from './components/ErrBatch.vue'
import {temperatureLayerOptions, INTYPE, OUTTYPE, INTYPECODE, OUTTYPECODE, WAREHOUSEACTIONS, inventoryType } from "./constant";
import {
  createWarehouseOrder,
  getOrderDetail,
  updateWarehouseOrder,
  getWareHouse,
  getCustomerList,
  createWarehouseMultipleOrder,
  updateWarehouseMultipleOrder
} from '../api.js'
import { getWareHouseContract, getCarType, fetchProject } from '../../orderManage/api.js'
import GoodsInfo from './components/GoodsInfo'
import StartStation from './components/StartStation'
import EndStation from './components/EndStation'
import CarrierInfo from './components/CarrierInfo.vue'
import File from './components/File'
import EndStationNoVerification from './components/EndStationNoVerification'
import inventoryBaseForm from './components/warehouseInventory/baseForm.vue'

const END_STATION = {
  stationId: '',
  contactName: '',
  contactPhone: '',
  provinceName: '',
  cityName: '',
  countyName: '',
  address: '',
  expectTime: null,
}
const warehouseType = {
  in: 'STORE',
  out: 'DELIVER',
  inventory: 'INVENTORY' // 盘点
}

const SCENE = {
  'DELIVER_ONLY': 'DELIVER_ONLY',            // 出库
  'DELIVER_TRANSPORT': 'DELIVER_TRANSPORT',  // 出库运输
  'STORE_ONLY': 'STORE_ONLY',  // 入库运输
  'STORE_TRANSPORT': 'TRANSPORT_STORE',  // 入库运输
  'DELIVER_STORE': 'DELIVER_STORE',  // 仓内调拨
  'DELIVER_TRANSPORT_STORE': 'DELIVER_TRANSPORT_STORE',  // 仓间调拨
}

const scenceType = {
  STORE: {
    1: SCENE.STORE_TRANSPORT,
    0: SCENE.STORE_ONLY,
  },
  DELIVER: {
    1: SCENE.DELIVER_TRANSPORT,
    0: SCENE.DELIVER_ONLY
  }
}

const STARTSTATION = {
  stationId: '',
  contactName: '',
  contactPhone: '',
  expectTime: null,
  provinceName: '',
  cityName: '',
  countyName: '',
  address: '',
}
const ENDSTATION = {
  stationId: '',
  contactName: '',
  contactPhone: '',
  provinceName: '',
  cityName: '',
  countyName: '',
  address: '',
  expectTime: null,
}
const PREDRAFT = 'PRE_DRAFT'

export default {
  name: 'WarehouseCreate',
  components: {
    GoodsInfo,
    // BlockPanel,
    StartStation,
    EndStation,
    SelectDom,
    ProjectSelect,
    EndStationNoVerification,
    FixBottom,
    BlockTitle,
    Auth,
    File,
    ErrBatch,
    cutCarrier,
    CarrierInfo,
    settlementModes,
    inventoryBaseForm,
  },
  mixins: [loadingMixin],
  props: {
    productList: {
      type: Array,
      default: () => []
    },
    showCarType: {
      type: Boolean,
      default: false
    },
    isDischarge: {
      type: Boolean,
      default: false
    },
    standardList: {
      type: Array,
      default: () => []
    },
    tab:{
      type:String,
      default: tabListType.WAREHOUSE
    }
  },
  inject: ['order'],
  data () {
    return {
      tabListType,
      temperatureLayerOptions,
      temperatureLayer:'全部', // 要求存储温区
      hasStandard: true,
      defaultTime: moment('00:00:00', 'HH:mm:ss'),
      warehouseType,
      oneMoreOrder: false,
      warehouseList: [],
      bottom: 0,
      loading: {
        onSubmit: false
      },
      projectALLData: [],
      FormValidator,
      isEditPage: false,
      odrNo: '',
      form: {
        projectId: '',
        projectName: '',
        needTransport: 0, // 是否运输，送货方式
        deliverWarehouseCode: '',
        storeWarehouseCode: '',
        selectWarehouseid: '',
        customerCode: '',
        customerId: '',
        customerName: '',
        crmNumber: '', // 外部订单号
        scene: warehouseType.in,
        type: INTYPECODE.order, // 入库类型
        needShelves: false,
        needHandling: false,
        remark: '',
        carTypeName: '',
        projectList: [],
        startStation: {
          stationId: '',
          contactName: '',
          contactPhone: '',
          expectTime: null,
          provinceName: '',
          cityName: '',
          countyName: '',
          address: '',
        },
        endStation: [
          {
            stationId: '',
            contactName: '',
            contactPhone: '',
            provinceName: '',
            cityName: '',
            countyName: '',
            address: '',
            expectTime: null,
          }
        ],
        carrierInfoReq: {
          driverInfoReqList: [{}]
        },
        stationGoodsList: [],
        // operateOptions: WAREHOUSEACTIONS[warehouseType.in].defaultValue,
        fileList: null,
        accessoryFiles:[], // 随车附件
        credentials: [], // 提货凭证
      },
      WAREHOUSEACTIONS, // 仓操作项
      rules: {
        startStation: {
          expectTime: [
            { required: true, message: '请选择需要取货时间', trigger: 'change' },
          ],
        },
        deliverWarehouseCode: [
          { required: true, message: '请选择仓库', trigger: 'blur' },
        ],
        planTime: [
          { required: true, message: '请选择计划到仓时间', trigger: 'change' },
        ],
        driverMobile: [
          { pattern: /^\d{1,12}$/, message: '请输入正确的手机号', trigger: 'blur' }
        ],
        needFinishTime: [
          { required: true, message: '请选择要求完成时间', trigger: 'change' },
        ],
        warehouseAreas:[
           { required: true, message: '请选择库区', trigger: 'change' },
        ]
        // projectId: [
        //     { required: true, message: '请选择项目', trigger: 'change' },
        // ],
      },
      endStations: [],
      accountData: {},
      selectAll: true,
      customerCodes: null,
      upLoading: false,
      listFlag: false,
      INTYPE,
      OUTTYPE,
      INTYPECODE, // 入库code
      OUTTYPECODE, // 出库code
      shipperCode: '',
      warehouseContract: null,
      orderStatus: '',
      PREDRAFT,
      noAuthentication: false, // 未认证
      authFlag: false,
      carTypeflag: false,
      carTypeList: [],
      allCarTypeList: [],
      isEnterprise: false,
      isBind: false,
      fetchOrganization: false,
      wmsTenantId: null, // 顶部选择了仓库对应的仓租户id
    }
  },
  computed: {
    ...mapGetters('orderRules', ['isOrderDemoVersion']),
    endStationData () {
      const { endStation, scene, needTransport } = this.form;
      if (scene === warehouseType.out && this.isDischarge && !needTransport) {
        return [endStation[0]]
      }
      return endStation
    },
    isDeliverTransport(){
      return this.tab === tabListType.DELIVER_TRANSPORT
    },
    isInventory(){
      // 盘点单
      return this.form.scene === warehouseType.inventory;
    },
  },
  created () {
    if (!this.standardList.find(item => item.value === 'warehouse')?.value) {
      this.hasStandard = false
      this.$message.error('无合同')
      return
    }
    const { creditCode } = this.$store.state.user
    this.isEnterprise = !!creditCode
    this.noAuthentication = !this.$store.state.user.customerId
    this.accountData = JSON.parse(localStorage.getItem('accountData'));
    this.form.parentId = this.accountData.id
    this.getCarType()
    this.getOrganization()
    this.init()
    if(this.order.isProjectControl) {
      this.rules = {
        ...this.rules,
        projectId: [
          {required: true, message: '请选择项目', trigger: 'change'},
        ]
      }
    }
    if(this.isDeliverTransport) { // 仓配一体
      this.form.scene = warehouseType.out
      this.orderWarehouseChange(warehouseType.out, true)
      this.form.needTransport = 1
      this.orderWarehouseChange(1)
    }
  },
  beforeDestroy () { },
  methods: {
    toProject() {
      this.$router.push('/organization')
    },
    changeGoods (list) {
      this.form.stationGoodsList = list
    },
    changeDischargeGoods (list) {
      const { endStation } = this.form;
      const newEndStation = endStation.map(item => {
        const goodsList = list?.filter(goods => goods.stationId === item.stationId)
        return { ...item, stationGoodsList: goodsList }
      })
      this.$set(this.form, 'endStation', newEndStation)
    },
    disabledDate (current) {
      return current < moment().subtract(1, 'days');
    },
    async getOrganization (value) {
      this.fetchOrganization = false
      const accountData = JSON.parse(localStorage.getItem('accountData'))
      const { userId, customerCode } = this.$store.state.user
      const data = {
        accountId: userId,
        relationOrgId: accountData?.id,
        relationType: 'DOWN',
        orgType: 'PROJECT',
        accountType: 'CUSTOMER',
        orgNameLike: value,
        // orgStatus: 'ENABLED',
        status:'ENABLE',
        customerCode,
      }
      const res = await fetchProject(data) || []
      this.fetchOrganization = true;
      const records = res.map(t => ({
        ...t,
        name: t.projectName || t.name,
        code:t.projectCode||t.code
      }))
      this.projectList = records.map((e) => {
        let subLabel = ''
        if (e.operationResp?.termName) {
          subLabel = `${e.operationResp.termName}`
        }
        return {
          ...e,
          value: `${e.id}`,
          label: e.name,
          subLabel,
          disabled: !e.enableStatus
        }
      })
      if (this.selectAll) {
        this.projectALLData = this.projectList
      }
    },
    checkProject (data) {
      this.form.projectName = data.name
      this.isBind = data.isBind
      if (data.isBind) {
        this.$set(this.form, 'productType', '')
      }
    },
    changeProductType (e) {
      const { value } = e.target
      const { productType } = this.form
      const type = value === productType ? '' : value
      this.$set(this.form, 'productType', type)
    },
    async getCarType () {
      const res = await getCarType({
        pageSize: '999'
      })
      this.carTypeflag = res.length > 0
      const arr = res.map((e) => {
        return {
          ...e,
          value: e.id,
          label: e.carSettingName
        }
      })
      this.carTypeList = sortNumber(arr, 'carSettingName')
      this.allCarTypeList = this.carTypeList
    },
    changeCarType (value) {
      this.form.carTypeName = value.carSettingName
      this.form.carTypeId = value.id
    },
    onSearchCarType (text) {
      this.carTypeList = this.allCarTypeList?.filter((e) => {
        return e.label.includes(text)
      })
    },
    removeCarType () {
      this.form.carTypeName = ''
      this.form.carTypeId = ''
    },
    handleCarTypeChange (value) {
      const current = this.allCarTypeList.find(item => item.id === value);
      this.$set(this.form.carrierInfoReq, 'carTypeName', current?.carSettingName || '')
    },
    handleSearchCarType (value, option) {
      const text = option.componentOptions?.children?.[0]?.text || ''
      return text.includes(value)
    },
    authSuccess () {
      this.$router.push('/authentication')
    },
    filterList () {
      if (this.shipperCode !== this.$store.state.user.customerCode) {
        // INTYPE[1].disabled = true
        INTYPE[1].disabled = false
      } else {
        INTYPE[1].disabled = false
      }
      return INTYPE
    },
    changeType (value) {
      const { form } = this;
      // 如果是仓配入库，且入库类型是退货入库，需要清空起始地
      if (form.scene === warehouseType.in && value === INTYPECODE.return) {
        this.form.startStation = { ...STARTSTATION }
      }
    },
    removeData () {
      this.form.defultName = ''
      this.form.deliverWarehouseCode = ''
    },
    async getCustomerList () {
      const data = {
        identityIds: [this.$store.state.user.customerId],
        type: 'ORG',
        needCustomerInfo: true,
        needRelation: true,
        carrierTenantId: this.$store.state.user.tenantId
      }
      const params = {
        page: 1,
        size: 200,
      }
      const res = await getCustomerList(data, params)
      const customerCodes = []
      res.records.forEach((e) => {
        if (e.customerInfo) {
          customerCodes.push(e.customerInfo.customerCode)
          if (e.childrenOrg && e.childrenOrg.length > 0) {
            e.childrenOrg.forEach((n) => {
              if (n.customerInfo?.customerCode) {
                customerCodes.push(n.customerInfo?.customerCode)
              }
            })
          }
        } else {
          customerCodes.push(this.$store.state.user.customerCode)
        }
      })
      this.customerCodes = customerCodes
      this.getWareHouse(customerCodes)
    },
    async getWareHouse (customerCodes = null, tenantName = null, flag = false) {
      const data = {
        customerCodes,
        tenantName,
        needExcludeDefaultTenant: true,
        // type: this.form.scene,
        needGroupByTenantId: false,
      }
      const res = await getWareHouse(data, { size: 500 })
      const list = res.records.map((e) => {
        return {
          ...e,
          label: `${e.tenantName}  (${e.shipperName})`,
          value: e.tenantId
        }
      })
      // 如果是仓配入库，且入库类型是退货入库，仓库不能选择下级仓库
      if (this.form.scene === warehouseType.in && this.form.type === INTYPECODE.return) {
        // const { customerCode } = this.$store.state.user
        // this.warehouseList = list?.filter((e) => {
        //   return e.shipperCode === customerCode
        // })
        this.warehouseList = list
      } else {
        this.warehouseList = list
      }
      if (!this.listFlag) {
        this.listFlag = true
      }
      if (flag) {
       this.checkedWarehouse(list[0] || {})
      }
      if(this.isEditPage || this.oneMoreOrder){
        const selectWarehouseid=this.warehouseList.find(item=>(item.value===this.form.deliverWarehouseCode&&item.label===this.form.defultName))
        this.$set(this.form,'selectWarehouseid',selectWarehouseid?.customerId || '')
      }

    },
    onSearchProjectList (value) {
      this.selectAll = false
      this.projectList = this.projectALLData?.filter((e) => {
        return e.label.includes(value)
      })
    },
    onSearchProject (tenantName) {
      if (this.form.scene === warehouseType.in) {
        this.getWareHouse(this.customerCodes, tenantName)
      } else {
        const code = this.getCode()
        this.getWareHouse(code, tenantName)
      }
    },
    getCode () {
      return this.$store.state.user.customerCode ? [this.$store.state.user.customerCode] : null
    },
   async orderWarehouseChange (value, issScene) {
      // 切换出入库类型，清空选择的货品信息
      if (issScene) {
        this.form.stationGoodsList = []
        this.form.deliverWarehouseCode = ''
        this.form.deliverWarehouseName = ''
        this.form.customerCode = ''
        this.form.customerId = ''
        this.form.customerName = ''
        if (this.form.scene === warehouseType.in) {
          await this.getWareHouse(this.customerCodes, null, true)
          this.form.type = INTYPECODE.order
          this.$nextTick(() => {
            this.form.startStation = { ...STARTSTATION };
            this.form.endStation = [ENDSTATION];
          })
        } else {
          this.form.needTransport = 0
          this.temperatureLayer = '全部';
          const code = this.getCode()
         await this.getWareHouse(code, null, true)
          this.form.type = OUTTYPECODE.order
          this.$nextTick(() => {
            if (this.isDischarge) {
              this.form.endStation = [{
                ...ENDSTATION,
                stationGoodsList: []
              }];
            } else {
              this.form.endStation = [ENDSTATION];
            }
          })
        }
        // const { scene } = this.form
        // this.form.operateOptions = this.WAREHOUSEACTIONS[scene].defaultValue
      } else {
        if (!value) {
          const { carTypeId, productType, carTypeName, ...restParams } = this.form
          this.form = {
            ...restParams
          }
        }
        // 切换到提货自动填充
        if(value && this.form.deliverWarehouseCode && !this.oneMoreOrder && !this.isEditPage) {
          const warehoseObj = this.warehouseList.find(item=>item.tenantId === this.form.deliverWarehouseCode)
          if(warehoseObj) {
            this.checkedWarehouse(warehoseObj, false)
          }
        }
        const { startStation, endStation } = this.form;
        this.form.startStation = { ...STARTSTATION };
        this.form.endStation = [ENDSTATION];
        this.$nextTick(() => {
          this.form = {
            ...this.form,
            startStation,
            endStation,
          }
        })
      }
      if(this.form.scene === warehouseType.inventory){
        this.$set(this.form,'countType',inventoryType[0].value);
      }
    },
    changeStation () {
      this.$refs.orderForm.clearValidate()
    },
    closeOrder () {
      this.$router.push('/order/warehouseList')
    },
    init () {
      this.odrNo = this.$route.query.odrNo
      // 再来一单标记
      this.oneMoreOrder = !!this.$route.query.oneMoreOrder;
      if (!this.oneMoreOrder) {
        this.isEditPage = !!this.odrNo
      }
      // 再来一单并且是企业视角需要请求授信预警
      if (this.isEnterprise && this.oneMoreOrder) {
        this.$emit('showTips')
      }
      this.getCustomerList()
      if (this.isEditPage || this.oneMoreOrder) {
        if(this.$route.query.scene===warehouseType.inventory){
          // 盘点单
          this.setInventoryDetail()
        }else{
          this.setDetail()
        }
      }
      if (!this.isEditPage) {
        // 获取仓合同
        this.warehouseContract = getWareHouseContract({
          cargoOwnerCode: this.$store.state.user.customerCode
        })
        if (!this.warehouseContract && this.warehouseContract.TRANSPORT.length <= 0) {
          this.form.needTransport = 0
        }
      }
    },
    dealTime(time){
      return moment(time).format('YYYY-MM-DD HH:mm')
    },
    getBatchAttrs(goods){
      const batchAttr = [
        {
          attrCode: undefined,
          attrName: '',
          attrValue: undefined
        }
      ]
      if(this.oneMoreOrder) {
        return batchAttr
      }
      return goods.wmsExt?.batchAttr?.length ? goods.wmsExt?.batchAttr: batchAttr
    },
    async setDetail () {
      const res = await getOrderDetail({
        unifyOdrNo: this.odrNo
      })
      // if (!res.isWarehouseMultiDischargeOrder && this.isDischarge) {
      //   this.$emit('changeDischarge', false)
      // }
      const orderMsgResList = res.orderMsgResList?.[0] || {}
      const scene = res.scene.includes(warehouseType.in) ? warehouseType.in : warehouseType.out
      this.orderStatus = res.status
      this.form = {
        ...this.form,
        scene,
        needTransport: res.needTransport ? 1 : 0,
      }
      this.$nextTick(() => {
        const carrierInfoReq = res.unifyWarehouseInfoList?.[0] || {};
        if (!carrierInfoReq.unifyWarehouseDriverInfoList?.length) {
          carrierInfoReq.driverInfoReqList = [{}]
        } else {
          carrierInfoReq.driverInfoReqList = carrierInfoReq.unifyWarehouseDriverInfoList.map(t=>({
            ...t,
            timeRange:t.predictDeliveryStartTime?[this.dealTime(t.predictDeliveryStartTime),this.dealTime(t.predictDeliveryEndTime)]:[]
          }))
        }
        this.form = {
          ...this.form,
          remark: res.remark,
          projectId: res.projectId || this.projectList?.[0]?.value || '',
          projectName: res.projectName || this.projectList?.[0]?.label || '',
          // scene,
          productType: res.ext?.productCode || null,
          carTypeId: res.orderMsgResList?.[0]?.carType || null,
          carTypeName: res.orderMsgResList?.[0]?.carLength || null,
          crmNumber: this.oneMoreOrder ? '' : res.crmNumber,
          customerCode: res.deliverCustomerCode || res.storeCustomerCode,
          unifyOrderNo: res.unifyOrderNo,
          needShelves: orderMsgResList.ext?.needShelves || false,
          needHandling: orderMsgResList.ext?.needHandling || false,
          deliverWarehouseCode: res.deliverWarehouseCode || res.storeWarehouseCode,
          deliverWarehouseName: `${res.deliverWarehouseName || res.storeWarehouseName}`,
          defultName: `${res.deliverWarehouseName || res.storeWarehouseName}  (${res.deliverCustomerName || res.storeCustomerName})`,
          planTime: this.oneMoreOrder ? null : moment(res.planTime), // 交货时间/计划到仓时间
          type: scene === warehouseType.in ? res.storeTypeCode || INTYPECODE.order : res.deliveryTypeCode || OUTTYPECODE.order, // 出/入库类型
          // operateOptions: res.ext?.operateOptions?.split(',') || [],
          carrierInfoReq
        }
        let endStation = [];
        let startStation = {};
        let stationGoodsList=[];
        if (res.needTransport && res.isWarehouseMultiDischargeOrder && this.isDischarge) {
          const [start = {}] = res.orderMsgResList;
          startStation = {
            stationId: start.startStationId || '',
            stationName: start.startStationName || '',
            contactName: start.consignorName || '',
            contactPhone: start.consignorTel || '',
            expectTime: this.oneMoreOrder || !start.startTime ? '' : moment(start.startTime),
            expectTimeLeft:start.startTime?[moment(start.startTime).format('HH:mm:ss')]:[],
            provinceName: start.consignorProvinceName || '',
            cityName: start.consignorCityName || '',
            countyName: start.consignorCountyName || '',
            provinceCode: start.consignorProvinceCode || '',
            cityCode: start.consignorCityCode || '',
            countyCode: start.consignorCountyCode || '',
            address: start.consignorAddress || '',
            stationFullAddress: start.consignorAddress || '',
          }
          endStation = res.orderMsgResList.map(item => {
            const [station] = item.orderStationList;
            return {
              id: item.rowid,
              stationId: station.stationId || '', //
              stationName: station.stationName || '', //
              contactName: station.recipientName || '',
              contactPhone: station.recipientTel || '',
              expectTime: this.oneMoreOrder || !item.reachTime ? '' : moment(item.reachTime),
              expectTimeLeft:item.reachTime?[moment(item.reachTime).format('HH:mm:ss')]:[],
              provinceCode: station.recipientProvinceCode || '',
              cityCode: station.recipientCityCode || '',
              countyCode: station.recipientCountyCode || '',
              provinceName: station.recipientProvinceName || '',
              cityName: station.recipientCityName || '',
              address: station.recipientAddress || '',
              countyName: station.recipientCountyName || '',
              stationFullAddress: station.recipientAddress || '',
              stationGoodsList: this.goodsFieldTran(station.stationCode, res.warehouseOrderResList),
            }
          })
        } else {
          startStation = {
            stationId: res.startStationId || '',
            stationName: res.startStationName || '',
            contactName: res.startStationContact || '',
            contactPhone: res.startStationContactPhone || '',
            expectTime: this.oneMoreOrder || !res.startTime ? '' : moment(res.startTime),
            expectTimeLeft:res.startTime?[moment(res.startTime).format('HH:mm:ss')]:[],
            provinceName: res.ext?.startStation?.provinceName,
            cityName: res.ext?.startStation?.cityName,
            countyName: res.ext?.startStation?.countyName,
            provinceCode: res.ext?.startStation?.provinceCode,
            cityCode: res.ext?.startStation?.cityCode,
            countyCode: res.ext?.startStation?.countyCode,
            address: res.ext?.startStation?.address,
          }
          endStation = [{
            id: orderMsgResList.rowid,
            stationId: res.endStationId || '',
            stationName: res.endStationName || '',
            contactName: res.endStationContact || '',
            contactPhone: res.endStationContactPhone || '',
            expectTime: this.oneMoreOrder || !res.endTime ? '' : moment(res.endTime),
            expectTimeLeft:res.endTime?[moment(res.endTime).format('HH:mm:ss')]:[],
            provinceCode: res.ext?.endStation?.[0]?.provinceCode,
            cityCode: res.ext?.endStation?.[0]?.cityCode,
            countyCode: res.ext?.endStation?.[0]?.countyCode,
            provinceName: res.ext?.endStation?.[0]?.provinceName,
            cityName: res.ext?.endStation?.[0]?.cityName,
            address: res.ext?.endStation?.[0]?.address,
            countyName: res.ext?.endStation?.[0]?.countyName,
          }]
          stationGoodsList= res.unifyOrderGoodsList.map(goods => {
            const flags = goods.temperatureZone.includes('~')
            return {
              skuId: goods.skuId,
              skuCode: goods.skuCode ? goods.skuCode : '',
              skuName: goods.skuName,
              number: goods.planAmount,
              weight: goods.planWeight,
              volume: goods.planVolume,
              skuNorms: goods.skuNorms,
              skuUnit: goods.skuUnit,
              stockBatch: goods.stockBatch || '',
              temperatureZone: flags ? 'custom' : goods.temperatureZone,
              hightemp: flags ? goods.temperatureZone.split('~')[1] : '',
              lowtemp: flags ? goods.temperatureZone.split('~')[0] : '',
              isOverWarehouse: Number(goods.wmsExt?.isOverWarehouse || false).toString(),
              // goodsValue: goods.skuValue ? goods.skuValue : 0,
              // id: scene === warehouseType.out ? goods.id : goods.skuId,
              id: goods.id,
              batchAttrs: this.getBatchAttrs(goods),
              designatedGoodsQuality: goods.wmsExt?.designatedGoodsQuality,
              storehouseId: this.oneMoreOrder?undefined:goods.wmsExt?.storehouseId,
              storehouseCode: this.oneMoreOrder?undefined:goods.wmsExt?.storehouseCode,
              storageDuration: goods.wmsExt?.storageDuration,
              productTime: moment(goods.wmsExt?.productTime).format('YYYY-MM-DD'),
            }
          })
          if (!res.needTransport && res.isWarehouseMultiDischargeOrder && this.isDischarge) {
            endStation[0].stationGoodsList = JSON.parse(JSON.stringify(this.form.stationGoodsList))
          }
        }
        this.$set(this.form, 'endStation', endStation)
        this.$set(this.form, 'startStation', startStation)
        this.$set(this.form, 'stationGoodsList', stationGoodsList)
      })
      this.$nextTick(() => {
        // 再来一单时项目不存在，默认选中第一条
        if (this.projectList?.filter((e) => {
          return e.value === this.form.projectId
        }).length <= 0) {
          if (this.oneMoreOrder) {
            this.form.projectId = this.projectList[0]?.value || ''
            this.form.projectName = this.projectList[0]?.label || ''
          } else {
            this.form.projectId = ''
            this.form.projectName = ''
          }
        }
        if (this.carTypeList?.filter(e => {
          return e.value === this.form.carTypeId
        }).length <= 0)  {
          if (this.oneMoreOrder && this.form.needTransport && this.showCarType) {
            this.form.carTypeId = this.carTypeList[0].value
            this.form.carTypeName = this.carTypeList[0].label
          } else {
            this.form.carTypeId = ''
            this.form.carTypeName = ''
          }
        }
      })
    },
    async setInventoryDetail(){
      const res = await externalInitiationOrderDetail({countPlanId:this.odrNo});
      const {externalOrderNo,countType,countRemark,zoneInfos,goodsInfos,fileAttachments} = res?.ext?.warehouseSupplierInfo||{};
       const temperature = {
        NORMAL:'常温',
        COLD:'冷冻',
        REFRIGERATE:'冷藏',
        CONSTANT:'恒温',
      }
      this.form = {
        deliverWarehouseCode:res.warehouseCode,
        deliverWarehouseName:res.tenantName,
        selectWarehouseid:res.shipperId,
        customerCode:res.shipperCode,
        customerId:res.shipperId,
        customerName:res.tenantName,
        defultName:`${res.tenantName}  (${res.shipperName})`,
        scene:warehouseType.inventory,
        needFinishTime: null,
        countType,
        crmNumber:externalOrderNo,
        remark:countRemark,
        fileList:fileAttachments.map(item=>({fileUrl:item.filePath,fileName:item.fileName})),
        externalOrderNo:this.form.crmNumber,
        countRemark:this.form.remark,
        zoneInfos,
        stationGoodsList:goodsInfos.map(item=>{
          return {
            skuId:item.goodsId,
            skuCode:item.goodsCode,
            shipperGoodsCode:item.shipperGoodsCode,
            skuName:item.goodsName,
            goodsQualitys:item.goodsQualitys,
            temperatureZone:temperature[item.temperatureLayer],
            availableStock:item.availableNum,
            // availableStockStr:item.availableStockStr
          }
        }),
        warehouseAreas:zoneInfos&&zoneInfos.length?zoneInfos.map(item=>item.zoneCode):[]
      }
      this.$nextTick(()=>{
        this.$refs.fileRef.setFileData(this.form.fileList)
        this.$refs.GoodsInfoRef.getWarehouseArea()
      })
    },
    goodsFieldTran (StationCode, goods) {
      // 一装多卸商品字段转换
      const goodsList = JSON.parse(JSON.stringify(goods.find(item => item.stationCode === StationCode)))
      return goodsList.warehouseOrderGoodsList.map(item => {
        const flags = item.temperatureZone.includes('~')
        return {
          skuId: item.skuId,
          skuCode: item.skuCode ? item.skuCode : '',
          skuName: item.skuName,
          number: item.planAmount,
          weight: item.planWeight,
          volume: item.planVolume,
          skuNorms: item.skuNorms,
          skuUnit: item.skuUnit,
          stockBatch: item.stockBatch || '',
          temperatureZone: flags ? 'custom' : item.temperatureZone,
          hightemp: flags ? item.temperatureZone.split('~')[1] : '',
          lowtemp: flags ? item.temperatureZone.split('~')[0] : '',
          isOverWarehouse: Number(item.wmsExt?.isOverWarehouse || false).toString(),
          // goodsValue: item.skuValue ? item.skuValue : 0,
          // id: scene === warehouseType.out ? item.id : item.skuId,
          id: item.id,
          batchAttrs: item.wmsExt?.batchAttr || [],
          designatedGoodsQuality: item.wmsExt?.designatedGoodsQuality,
          storehouseId: item.wmsExt?.storehouseId,
          storehouseCode: item.wmsExt?.storehouseCode,
        }
      })
    },
    async getStation(wmsTenantId){
      if(wmsTenantId) {
        const res = await getStationByWarehouse({wmsTenantId})
        return res[0]
      }
      return {}
    },
    async checkedWarehouse (data, blo = true) {
      this.$set(this.form, 'deliverWarehouseCode', data.value)
      this.$set(this.form, 'deliverWarehouseName', data.tenantName)
      this.$set(this.form, 'defultName', data.label)
      this.$set(this.form, 'selectWarehouseid', data.customerId)
      this.$set(this.form, 'customerCode', data.shipperCode)
      this.$set(this.form, 'customerId', data.customerId)
      this.$set(this.form, 'customerName', data.tenantName)
      this.wmsTenantId = data.tenantId
      this.shipperCode = data.shipperCode
      // 填充仓库站点信息
      const { scene } = this.form
      const res = await this.getStation(data.tenantId)
      const station = res || {}
      const {
        id,
        contacts = '',
        telPhone = '',
        provinceCode = '',
        provinceName = '',
        cityName = '',
        cityCode = '',
        countyName = '',
        countyCode = '',
        address = '',
      } = station
      const form = {
        stationId: id,
        contactName: contacts,
        contactPhone: telPhone,
        expectTime: null,
        provinceName,
        provinceCode,
        cityName,
        cityCode,
        countyName,
        countyCode,
        address,
        stationFullAddress: `${provinceName}${cityName}${countyName}${address}`
      }
      if (scene === this.warehouseType.in) {
        // 入库目的地填充仓库站点信息
        this.$set(this.form, 'endStation', [{ ...form }])
      } else {
        // 出库起始地填充仓库站点信息
        this.$set(this.form, 'startStation', { ...form })
      }
      if (blo) {
        this.form.stationGoodsList = []
        if(this.isDischarge){
          this.$set(this.form, 'endStation', this.form.endStation.map(item=>({...item,stationGoodsList:[]})))
        }
      }
    },
    async inventorySubmit () {
      await this.$refs.orderForm.validate()
      const { countType, zoneInfos, needFinishTime, deliverWarehouseCode,stationGoodsList,fileList=[] } = this.form;
      if(countType===inventoryType[0].value&&!stationGoodsList.length){
        this.$message.warning('请选择货品!');
        return
      }
      const warehouse = this.warehouseList?.find(item => (item.value === deliverWarehouseCode && item.shipperCode === this.form.customerCode));
      const { userId, customerCode,customerName,customerId,realName, } = this.$store.state.user;
      const params = {
        customerId,
        customerCode,
        customerName,
        tenantId:warehouse.tenantId,
        tenantName:warehouse.tenantName,
        shipperId: warehouse.customerId,
        shipperCode:warehouse.shipperCode,
        shipperName:warehouse.shipperName,
        createUserName:realName,
        createUserId:userId,
        warehouseSupplierInfo:{
          needFinishTime:moment(needFinishTime).format('YYYY-MM-DD HH:mm'),
          countType,
          externalOrderNo:this.form.crmNumber,
          countRemark:this.form.remark,
          fileAttachments:fileList&&fileList.length?fileList.map(item=>({filePath:item.fileUrl,fileName:item.fileName})):[],
        }
      }
      const temperature = {
        常温:'NORMAL',
        冷冻:'COLD',
        冷藏:'REFRIGERATE',
        恒温:'CONSTANT',
      }
      if(countType===inventoryType[0].value){
        params.warehouseSupplierInfo.goodsInfos = stationGoodsList.map(item=>{
          return {
            goodsId:item.skuId,
            goodsCode:item.skuCode,
            shipperGoodsCode:item.shipperGoodsCode,
            goodsName:item.skuName,
            goodsQualitys:item.goodsQualitys,
            temperatureLayer:temperature[item.temperatureZone],
            availableStock:item.availableNum,
            availableStockStr:item.availableAmount,
          }
        });
      }else{
        params.warehouseSupplierInfo.zoneInfos = zoneInfos;
      }
      try {
        this.upLoading = true;
        await batchSaveCountPlanFormOms([{...params}])
        this.$message.success(`订单${this.isEditPage ? '编辑' : '创建'}成功`)
        setTimeout(() => {
          this.$router.push('/order/inventoryOrder')
          this.upLoading = false
        }, 1000)
      } catch (error) {
        this.upLoading = false
      }
    },
    async onSubmit () {
      if(this.form.scene === this.warehouseType.inventory){
        // 盘点提交
        try {
          this.inventorySubmit();
        } catch (error) {
          this.errorScroll()
        }
        return
      }
      if (this.form.scene === this.warehouseType.out) {
        const goods = this.form.stationGoodsList;
        // 创建一个 Map 来进行提取，以属性值为键，对象为值
        const extractedMap = new Map();
        goods.forEach(obj => {
          const key = obj.skuId + JSON.stringify(obj.batchAttrs); // 以 id 属性为键进行提取

          if (!extractedMap.has(key)) {
            extractedMap.set(key, []);
          }

          extractedMap.get(key).push(obj);
        });
        const uniqueExtractedArray = Array.from(extractedMap.values()).filter(arr => arr.length > 1);
        const resultArray = [].concat(...uniqueExtractedArray);
        const uniqueGoods =  Array.from(new Set(resultArray.map(item=>item.skuName)))
        if(uniqueGoods.length) {
          this.$message.error(`${uniqueGoods.join(',')}商品存在相同的批属性，请检查处理后再提交`)
          return
        }
      }
      this.upLoading = true
      // 验证站点是否是高德地址
      // if(this.form.needTransport && (!this.form.endStation[0].countyName || !this.form.startStation.countyName)){
      //     this.upLoading = false
      //     this.$message.warning('详细地址，请选择高德地址')
      //     return
      // }
      let res = null
      try {
        // isDischarge:一装多卸白名单  form.scene:订单类型  warehouseType.out:出库  form.needTransport:需要运输
        await this.$refs.orderForm.validate()
        if(this.isOrderDemoVersion){
        // 当前货主属于在"货主端仓下单演示版本名单"内,在提交前弹窗选择结算方式
          await this.$refs.settlementModes.show()
        }
        if (this.isDischarge && this.form.scene === warehouseType.out && this.form.needTransport) {
          // 一装多卸
          res = await this.onceLoadMultipleUnload();
        } else {
          res = await this.submitOrder()
        }
      } catch {
        this.upLoading = false
        this.errorScroll()
        return
      }
      if (res && res.isSuccess) {
        this.$message.success(`订单${this.isEditPage ? '编辑' : '创建'}成功`)
        this.$route.meta.canRefresh = true
        setTimeout(() => {
          this.$router.push('/order/warehouseList')
          this.upLoading = false
        }, 1000)
      } else {
        this.upLoading = false
        this.$refs.errBatch.show(res.goodsReq || [], this.form.deliverWarehouseCode)
      }
    },
    async onceLoadMultipleUnload () {
      const params = this.buildParams()
      const goodsList = [];
      params.endStation.forEach(item => {
        if (item.stationGoodsList && item.stationGoodsList.length) {
          goodsList.push(...item.stationGoodsList.map(child => ({ ...child, stationId: item.stationId, stationFullAddress: item.stationFullAddress })))
        }
      })
      params.stationGoodsList = goodsList;
      const { endStation, endStationList, startStation, ...restParams } = params;
      const endList = endStationList.map(item => ({ ...item, contacts: item.contactName, telPhone: item.contactPhone }))
      const data = {
        ...restParams,
        endStationList: params.needTransport ? endList : [endList[0]],
      }
      if (params.needTransport) {
        const start = { ...startStation, contacts: startStation.contactName, telPhone: startStation.contactPhone }
        data.startStation = start;
      }
      if (this.isEditPage) {
        const res = await updateWarehouseMultipleOrder({
          ...data,
          unifyOrderNo: this.odrNo
        })
        return res
      }
      const res = await createWarehouseMultipleOrder({ ...data })
      return res
    },
    errorScroll () {
      // const errDomList = document.querySelectorAll('.has-error')
      // if (errDomList[0]) {
      //   errDomList[0].scrollIntoView({ behavior: "smooth", block: "center", inline: "center" });
      // }
      this.$nextTick(()=>{
        scrollToTargetWareHourse('.has-error')
      })
    },
    async submitOrder () {
      const params = this.buildParams()
      if (this.isEditPage) {
        const res = await updateWarehouseOrder({
          ...params,
          unifyOrderNo: this.odrNo
        })
        return res
      }
      const res = await createWarehouseOrder(params)
      return res
    },
    buildParams () {
      const { endStation, startStation, warehouseAreas, zoneInfos, needFinishTime, ...otherParams } = this.form
      const endStationList = []
      this.form.storeWarehouseCode = this.form.deliverWarehouseCode
      const warehouse = this.warehouseList?.filter(item => (item.value === this.form.storeWarehouseCode && item.shipperCode === this.form.customerCode))
      endStation.forEach(item => {
        const { ...otherEndStation } = item
        endStationList.push({
          ...otherEndStation,
          expectTime: moment(otherEndStation.expectTime).valueOf()
        })
      });
      const stationGoodsList = []
      this.form.stationGoodsList.forEach(item => {
        stationGoodsList.push({
          ...item,
          stationId: endStation[0].stationId,
          stationFullAddress: endStation[0].stationFullAddress,
          isOverWarehouse: !!Number(item.isOverWarehouse)
        })
      })
      // const stationGoodsList = this.form.stationGoodsList.map(item => {
      //     const station = item
      //     station.stationId = endStation[0].stationId
      //     station.stationFullAddress = endStation[0].stationFullAddress
      //     station.isOverWarehouse = !!Number(item.isOverWarehouse)
      //     return item
      // })
      const test = {
        ...otherParams,
        endStation,
        stationGoodsList,
        storeWarehouseCode:this.form.deliverWarehouseCode,
        // transportType: "TRUCKLOAD",
        needTransport: otherParams.needTransport,
        startStation: {
          ...startStation,
          expectTime: moment(startStation.expectTime).valueOf()
        },
        scene: scenceType[this.form.scene][otherParams.needTransport], // 根据订单类型和是否需要运输组装scene
        endStationList,
        planTime: moment(otherParams.planTime).valueOf()
      }
      // 不需要运输清空起始地目的地数据
      if (!this.form.needTransport && ((this.form.scene === warehouseType.in && otherParams.type !== INTYPECODE.return) || (this.form.scene === warehouseType.out && (otherParams.type === OUTTYPECODE.transfer || otherParams.type === OUTTYPECODE.transferBetween)))) {
        test.startStation = null;
        test.endStation = null;
        test.endStationList = null;
      }
      if (this.form.needTransport || this.form.scene === warehouseType.out) {
        test.carrierInfoReq = null
      } else {
        test.carrierInfoReq = { ...this.form.carrierInfoReq }
        const driverInfoReqList = []
        let driver = this.form.carrierInfoReq?.driverInfoReqList || []
        const keysList = ['driverName', 'driverPhone', 'carType', 'licensePlate', 'timeRange']
        driver = driver.length > 0 ? driver.map(t => ({
          ...t,
          predictDeliveryStartTime: t.timeRange && t.timeRange[0]?`${t.timeRange[0]}:00`:"",
          predictDeliveryEndTime:t.timeRange && t.timeRange[1]?`${t.timeRange[1]}:00`:"",
        })):[]
        driver.forEach(i => {
          let num = 0
          keysList.forEach(k => {
            if (i[k]) {
              num += 1
            }
          })
          if (num) {
            driverInfoReqList.push(i)
          }
        })
        test.carrierInfoReq.driverInfoReqList = driverInfoReqList
      }
      // 纯入库且类型不是退货入库不传起始地和目的地信息
      if (test.scene === SCENE.STORE_ONLY && otherParams.type !== INTYPECODE.return) {
        test.startStation = undefined
        // test.endStationList = undefined
        // 纯出库不传起始地信息
      } else if (test.scene === SCENE.DELIVER_ONLY) {
        test.startStation = undefined
      }
      // 入库时，不传出库仓库
      if (this.form.scene === warehouseType.in) {
        test.storeWarehouseName = warehouse[0]?.tenantName
        test.storeCustomerCode = warehouse[0]?.shipperCode
        test.storeCustomerName = warehouse[0]?.shipperName
        test.deliverWarehouseCode = undefined
        test.deliverWarehouseName = undefined
        test.storeTypeCode = otherParams.type
        // 如果是入库不含运输且类型为退货入库，目的地信息为空
        if (this.form.needTransport !== 1 && otherParams.type === INTYPECODE.return) {
          test.endStation = undefined
          test.endStationList = undefined
        }
        // 出库时，不传入库仓库
      } else {
        test.deliverWarehouseName = warehouse[0]?.tenantName
        test.deliverCustomerCode = warehouse[0]?.shipperCode
        test.deliverCustomerName = warehouse[0]?.shipperName
        test.customerId = warehouse[0]?.customerId
        test.storeWarehouseCode = undefined
        test.storeWarehouseName = undefined
        test.deliveryTypeCode = otherParams.type
        // 如果是出库不需要运输且类型为调拨出库，目的地信息为空
        if (this.form.needTransport !== 1 && (otherParams.type === OUTTYPECODE.transfer || otherParams.type === OUTTYPECODE.transferBetween)) {
          test.endStation = undefined
          test.endStationList = undefined
        }
      }
      return test
    },
    // 删除货品
    onDeleteGoods (goodsList, index) {
      goodsList.splice(index, 1)
    },
    // 添加目的地
    onAddEndStation () {
      this.form.endStation.push({
        ...END_STATION,
        stationGoodsList: []
      })
    },
    // 删除目的地
    onDeleteEndStation (index) {
      this.form.endStation.splice(index, 1)
    },
    handleAfreshVali (prop) {
      this.$refs.orderForm.validateField(prop)
    },
    handleRefreshAll () {
      this.$refs.orderForm.clearValidate()
    },
    handleGoods(list){
      this.$set(this.form,'stationGoodsList',list)
    }
  }
}
</script>

<style lang="less" scoped>
.order-manage-create-page {
  .ant-card-bordered {
    border: none;
  }
}

.station-add {
  .ant-btn {
    background: #F2FBF8;
    border: 1px dashed #06B880;
    line-height: 48px;
    height: 48px;
    margin-top: 20px;

    &:hover {
      background: #029869;
      border: 1px dashed #029869;
      transition: all 1s;
      color: #FFFFFF;
    }
  }
}

.OrderManageCreate-root {
  margin-bottom: 50px;

  .margin-left {
    margin-left: 10px;
  }

  .margin-top {
    margin-top: 12px;
  }

  .block-container {
    background: #FFFFFF;
    border-radius: 6px;
    padding: 32px 0px;

    >div:not(:first-of-type) {
      margin-top: 50px;
    }

    .title {
      margin-bottom: 25px;
    }

    .basic {
      .content {
        padding-right: 24px;
      }

      /deep/ .icon {
        background: #171717;
      }
    }

    .destination {
      /deep/ .icon {
        background: #FB9432;
      }

      .deleteStyle {
        margin: 0 24px;
        color: #F56C6C;

        &:hover {
          cursor: pointer;
        }
      }
    }

    .origin-station {
      /deep/ .icon {
        background: #06B880;
      }
    }
  }

  .added-services {
    display: flex;
    align-items: center;
    margin: 32px 0px 16px 0px;

    h2 {
      font-size: 20px;
    }

    p {
      margin-left: 19px;
      color: #A9ABAE;
      font-size: 14px;
    }
  }
}

.odr-txt {
  position: absolute;
  top: -50px;
  right: 30px;
  z-index: 1;
  color: #666;
}

.with-card-box {
  margin-top: 26px;
}

.align-right {
  margin-left: -30px;
  text-align: right;
  height: 50px;
  // background-color: #f0f2f5;
  background-color: #ffffff;
  box-shadow: 0px -5px 5px -5px rgba(0, 0, 0, 0.2);
  padding-top: 10px;
  box-sizing: border-box;
  padding-right: 30px;
  box-sizing: border-box;

  .close {
    margin-right: 30px;
  }
}

.remark-input {
  width: 500px;
}

/deep/ .ant-space-vertical {
  width: 100%;
}

.radioStyle {
  color: #06b880;
}

/deep/ .ant-calendar-picker {
  // max-width: 302px !important;
  width: 100%;
}

.porject-label {
  background: #fff;
  padding: 8px 24px 0px 24px;

  .projectTitle {
    display: flex;
    align-items: center;

    .item-line {
      width: 4px;
      height: 18px;
      background: #06B880;
      border-radius: 2px;
      margin-right: 10px;
    }

    .subtitle {
      font-weight: bold;
      font-size: 16px;
    }
  }

  .content {
    width: 100%;

    .itemBox {
      overflow: hidden;
    }
  }
}

/deep/ .ant-card-body {
  padding: 24px 24px 2px 24px !important;
}

/deep/ .ant-form-item {
  margin-bottom: 19px !important;
}

/deep/ .ant-form-item-with-help {
  margin-bottom: 0px !important;
}

.maks {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 10;
  cursor: no-drop;
}

.authMaks {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 100px;
  left: 0;
  z-index: 1000;
}

/deep/ .ant-radio-wrapper-checked {
  color: #06B880 !important;
}

.projectTitle {
  display: flex;
  align-items: center;

  .item-line {
    width: 4px;
    height: 18px;
    background: #06B880;
    border-radius: 2px;
    margin-right: 10px;
  }

  .subtitle {
    font-weight: bold;
    font-size: 16px;
  }
}

.contrat-container {
  background: #F2FBF8;
  border-radius: 6px;
  border: 1px solid #E7E9EC;
  padding: 12px 24px;
  margin-bottom: 12px;

  img {
    width: 24px;
    height: 24px;
    margin-right: 10px;
  }

  .replaceContract {
    color: #06B880;
    margin-left: 20px;

    &:hover {
      cursor: pointer;
    }
  }

  .contractTitleName {
    font-weight: 500;
    margin-left: 12px;
    font-size: 16px;
  }
}
.ml32{
  margin-left: 32px;
}
</style>
